import React, { useEffect, useRef, useState } from "react";
import "../css/layout.css";
import css from "../css/Profile.module.css";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import Rightcontainer from "../Components/Rightcontainer";
import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "../css/kyc.css";
import "../css/Loader.css";
import { FaUser } from "react-icons/fa";
import { IoIosCall } from "react-icons/io";
import { HiOutlineMail } from "react-icons/hi";
import { IoIosLogOut } from "react-icons/io";
import findGif from "../css/loading_old.gif";
import { apiRequest } from "../store/allApi";
import io from "../Components/socket";
import Socket from "./../Components/socket";

const Profile1 = ({ profile1 }) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  // alert(baseUrl)
  // +++++++++++++++++++++++++++++
  const [show, setShow] = useState(false);

  const [show1, setShow1] = useState(false);

  const handleClose = () => setShow1(false);
  const handleShow = () => {
    setShow1(true);
  };

  const [referral, setCode] = useState("");
  const [Id, setId] = useState(null);

  const [profile, setProfile] = useState();
  const [portcss, setPortcss] = useState(css.active_tab);
  const [portcss1, setPortcss1] = useState(css.inactive_tab);
  const [crushcss, setCrushcss] = useState(true);
  const [holder_name, setHolder_name] = useState();
  const [account_number, setAccount_number] = useState();
  const [ifsc_code, setIfsc_code] = useState();
  const [upi_id, setUpi_id] = useState();
  const [isLoading, setIsloading] = useState(false);

  // KYC MODEL

  const [showKyc, setShowKyc] = useState(false);
  const [showBottom, setShowBottom] = useState(false);
  const [process1, setProcesss] = useState(false);

  const handleCloseBottom = () => setShowBottom(false);
  const handleShowBottom = (data) => {
    setShowBottom(true);
  };
  const handleCloseKyc = () => {
    setShowKyc(false);
    window.location.reload();
  };
  const handleShowKyc = () => setShowKyc(true);
  const [inputOpen, setInputOpen] = useState(false);
  const [Email, setEmail] = useState();

  const toggleInput = () => {
    setInputOpen(!inputOpen);
  };

  const history = useHistory();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    io.on("setProfile", (data) => {
      setOpen(data?.superUser);
      localStorage.setItem("udata", JSON.stringify(data));
    });
  }, [Socket]);

  useEffect(() => {
    Me();
    const data = localStorage.getItem("udata");
    const userData = JSON.parse(data);
    setOpen(userData?.superUser);
  }, []);

  const Me = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest("me", "GET", null, headers);
      setProfile(res.data);
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        history.push("/login");
      }
    }
  };

  const logout = async () => {
    localStorage.clear();

    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(`me`, "GET", null, headers);
      if (res.data) {
      }
    } catch (e) {
      if (e.response.status == 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("token");
        window.location.reload();
        history.push("/login");
      }
    }
  };

  const UpdateEmail = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    axios
      .patch(baseUrl + `user/profile/edit`, { Email }, { headers })
      .then((res) => {
        if (res.data.status == false) {
          Swal.fire({
            title: res.data.msg,
            icon: "error",
            confirmButtonText: "OK",
          });
        } else {
          setEmail(res.data);
          setInputOpen(false);
          Swal.fire({
            title: res.data.msg,
            icon: "Success",
            confirmButtonText: "OK",
          });
          // UserALL();
        }
      })
      .catch((e) => {
        // setLoading(false)
      });
  };

  // name Update
  const [Name, setName] = useState();

  const handleNameChange = (e) => {
    const enteredName = e.target.value;

    if (enteredName.length <= 10) {
      setName(enteredName);
    } else {
      Swal.fire({
        title: "Name lessthen 10 characters)",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  // siteSetting
  const [isOnlineKyc, setOnKyc] = useState(false);
  const [isOfflineKyc, setOffKyc] = useState(false);
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  useEffect(() => {
    if (addCaseSetting.isOfflineKyc) {
      setOffKyc(true);
    } else {
      setOnKyc(true);
    }
  }, []);

  const UpdateProfile = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    axios
      .patch(baseUrl + `user/profile/edit`, { Name }, { headers })

      .then((res) => {
        console.log(res);

        // meeApi();
        if (res.data.status == false) {
          Swal.fire({
            title: res.data.msg,
            icon: "error",
            confirmButtonText: "OK",
          });
        } else {
          setEmail(res.data);
          setInputOpen(false);
          Swal.fire({
            title: res.data.msg,
            icon: "success",
            confirmButtonText: "OK",
          });
          // UserALL();
        }
      })

      .catch((e) => {
        // setLoading(false)
      });
  };
  const updateBankDetails = async (e) => {
    e.preventDefault();
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    const data = await axios
      .patch(
        baseUrl + `user/edit`,
        {
          holder_name,
          account_number,
          ifsc_code,
          upi_id,
        },
        { headers },
      )
      .then((res) => {
        console.log(res.data);
        if (res.status == 200) {
          setShow((prev) => !prev);
          // UserALL();
          let message;
          message = res.data.msg;
          if (!res.data.msg) {
            message = "something went wrong";
          }
          Swal.fire({
            title: message,
            icon: res.data.submit ? "success" : "error",
            confirmButtonText: "OK",
          });
        }
      });
  };
  const update_RefCode = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    axios
      .patch(baseUrl + `user/profile/edit`, { referral }, { headers })
      .then((res) => {
        if (res.data.submit == false) {
          Swal.fire({
            title: res.data.msg,
            icon: "error",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            title: res.data.msg,
            icon: "success",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((e) => {
        // setLoading(false)
      });
  };
  //// total game
  const [total, setTotal] = useState();

  const TotalGame = async (Id) => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");

    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const res = await apiRequest(
        `total/user/all/${userId}`,
        "GET",
        null,
        headers,
      );
      if (res.data) {
        setTotal(res.data);
      }
    } catch (e) {
      {
      }
    }
  };

  const [pic, setPic] = useState();

  const Result = async (file) => {
    if (file) {
      const access_token = localStorage.getItem("token");

      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const formData = new FormData();
      formData.append("avatar", file);

      try {
        const res = await apiRequest(
          `users/me/avatar`,
          "POST",
          formData,
          headers,
        );
        if (res.data) {
        }
      } catch (e) {
        // setLoading(false)
      } finally {
      }
    }
  };
  //avatar

  const Kyc = async () => {
    setShowKyc(true);
    const inputOptions = new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          "Auto Kyc": "Auto Kyc",
          "Complete Kyc": "Complete Kyc",
        });
      }, 1000);
    });
  };

  // AADHAR API

  const [AadharNum, setAadharNum] = useState("");
  const [userAdharData, setUserAdharData] = useState("");
  const [msg, setMsg] = useState("");
  // const handleAdharChnage = (e) => {
  //   setAadharNum(e.target.value);
  // };
  const handleAdharChnage = (e) => {
    const inputValue = e.target.value;

    if (/^[0-9]*$/.test(inputValue) || inputValue === "") {
      if (inputValue.length <= 12) {
        setAadharNum(inputValue);
      }
    }
  };
  const AdharNumber = async (e) => {
    setIsloading(true);
    e.preventDefault();

    // Ensure AadharNum is a 12-digit number before making the API call
    if (/^[0-9]{12}$/.test(AadharNum)) {
      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      const data = {
        aadharNumber: AadharNum,
      };
      try {
        const res = await apiRequest("aadharcard-auto", "POST", data, headers);
        setUserAdharData(res?.data);
        setIsloading(false);

        if (res.data.status === false) {
          setMsg(res?.data?.msg);
        } else {
          setMsg(res?.data?.data?.message);
          // Swal.fire({
          //   icon: "success",
          //   title: "Send OTP to your mobile number",
          //   text: res?.data?.data?.data?.message,
          // });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Invalid Aadhar Number",
        text: "Please enter a valid 12-digit Aadhar number.",
      });
      setIsloading(false);
    }
  };
  const AdharOtp = async (e) => {
    setIsloading1(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const data = {
      aadharNumber: AadharNum,
      otp: AadharOtp,
      Email: Email,
      transaction_id: userAdharData.data?.ref_id,
    };

    try {
      const res = await apiRequest(
        `aadharcard-auto-verify`,
        "POST",
        data,
        headers,
      );
      setKycdata(res.data);
      setVerifyData(res.data);
      setIsloading1(false);

      if (res.data.status === false) {
        setMsg(res.data?.msg);
      } else {
        window.location.reload();
      }
    } catch (e) {
      console.log(e);
    }
  };
  const [AadharOtp, setAadharOtp] = useState("");
  const [verifyData, setVerifyData] = useState("");
  const [kycdata, setKycdata] = useState();
  const [isLoading1, setIsloading1] = useState(false);

  const handleAdharOtpChnage = (e) => {
    setAadharOtp(e.target.value);
  };

  // DOCUMENTATION API START

  let aadharProcess = useRef(false);

  const [Names, setNames] = useState("");
  const [DOB, setDob] = useState("");
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);

  const handleSubmitdata = async (e) => {
    e.preventDefault();

    if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
      alert("Please fill in all fields and upload both images.");
      return;
    }

    if (aadharProcess.current === false) {
      setProcesss(true);
      aadharProcess.current = true;

      const formData = new FormData();
      formData.append("Name", Names);
      formData.append("DOB", DOB);
      formData.append("front", frontLoaded[0]);
      formData.append("back", backLoaded[0]);
      formData.append("Number", AadharNum);
      formData.append("Email", Email);

      const access_token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${access_token}`,
      };

      try {
        const res = await apiRequest("aadharcard", "POST", formData, headers);
        if (res.data.status === false) {
          Swal.fire({
            title: res.data.msg,
            icon: "error",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              handleCloseKyc();
            }
          });
        } else if (res.data.msg === "Duplicate Entity") {
          Swal.fire({
            title: "Duplicate Entity",
            icon: "error",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              handleCloseKyc();
            }
          });
        } else {
          Swal.fire({
            title: "Your KYC form submitted",
            icon: "success",
            confirmButtonText: "OK",
          }).then((result) => {
            if (result.isConfirmed) {
              handleCloseKyc();
            }
          });
          history.push("/Profile");
        }

        aadharProcess.current = false;
        setProcesss(false);
      } catch (error) {
        console.error(error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem("token");
          window.location.reload();
          history.push("/login");
        }
      }
    } else {
      alert("You have submitted a request already.");
    }
  };

  useEffect(() => {
    // UserALL();
    TotalGame();
  }, []);

  // Email validations
  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);

    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const isValidFormat = emailRegex.test(newEmail);

    const endsWithCom = newEmail.toLowerCase().endsWith(".com");

    setIsValidEmail(isValidFormat && endsWithCom);
  };

  return (
    <>
      {/* <Header user={profile} /> */}
      {
        <div
          className="leftContainer bg-body mb_space"
          style={{
            minHeight: "100vh",
            paddingTop: "70px",
            background: "#fcf9f0",
            paddingBottom: "60px",
          }}
        >
          <div className="profile_page_premium">
            <div className="premium_card_wrapper">
              {/* Header Background Section */}
              <div
                className="profile_banner_overlay"
                style={{ backgroundImage: "url(/images/profile.jpg)" }}
              >
                <div className="avatar_center_box">
                  <label className="avatar_upload_label">
                    <input
                      className="d-none"
                      type="file"
                      onChange={(e) => Result(e.target.files[0])}
                      accept="image/*"
                      required
                    />
                    <div className="avatar_ring">
                      {profile1 && profile1.avatar ? (
                        <img
                          className="user_media_modern"
                          src="/images/avatars/Avatar6.png"
                          alt="Profile"
                        />
                      ) : (
                        <img
                          className="user_media_modern"
                          src={
                            process.env.PUBLIC_URL +
                            `/images/avatars/Avatar7.png`
                          }
                          alt="Profile"
                        />
                      )}
                      <div className="edit_badge_mini">
                        <img src="/images/icon-edit.jpg" alt="edit" />
                      </div>
                    </div>
                  </label>
                 
                </div>
              </div>

              {/* Details Content Section */}
              <div className="profile_info_glass_box">
                {/* Name Section */}
                <div className="info_item_row">
                  <div className="info_label_group">
                    <FaUser className="premium_icon" />
                    <div className="info_text_content">
                      <label>Full Name</label>
                      <h3 className="info_value_text">
                        {profile && profile.Name}
                        <img
                          className="inline_edit_icon"
                          src={process.env.PUBLIC_URL + "/images/icon-edit.jpg"}
                          alt="edit"
                          onClick={() => {
                            setPortcss(css.inactive_tab);
                            setPortcss1(css.active_tab);
                          }}
                        />
                      </h3>
                    </div>
                  </div>

                  {/* Name Edit Input Logic */}
                  <div className={`modern_edit_input_field ${portcss1}`}>
                    <div className="input_group_modern">
                      <input
                        type="text"
                        maxLength={"20"}
                        placeholder="Enter Username"
                        value={Name}
                        onChange={(e) => setName(e.target.value)}
                      />
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/images/select-blue-checkIcon.png"
                        }
                        alt="save"
                        className="save_check_icon"
                        onClick={() => {
                          setPortcss(css.active_tab);
                          setPortcss1(css.inactive_tab);
                          UpdateProfile(Id);
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* Phone Section */}
                <div className="info_item_row">
                  <div className="info_label_group">
                    <IoIosCall className="premium_icon" />
                    <div className="info_text_content">
                      <label>Phone Number</label>
                      <h3 className="info_value_text">
                        {profile && profile?.Phone}
                      </h3>
                    </div>
                  </div>
                </div>

                {/* Email Section */}
                <div className="info_item_row">
                  <div className="info_label_group">
                    <HiOutlineMail className="premium_icon" />
                    <div className="info_text_content">
                      <label>Email Address</label>
                      <div className="email_display_flex">
                        {profile?.Email === null ? (
                          <span className="unverified_label">
                            Verification Pending
                          </span>
                        ) : (
                          <h3 className="info_value_text">{profile?.Email}</h3>
                        )}
                        <img
                          className="inline_edit_icon"
                          src="/images/icon-edit.jpg"
                          alt="edit"
                          onClick={toggleInput}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Email Edit Input Logic */}
                  {inputOpen && (
                    <div className="modern_edit_input_field active_tab">
                      <div className="input_group_modern">
                        <input
                          type="email"
                          placeholder="Enter your email"
                          value={Email}
                          onChange={handleEmailChange}
                        />
                        <img
                          src="/images/select-blue-checkIcon1.png"
                          alt="save"
                          className="save_check_icon"
                          onClick={() => {
                            toggleInput();
                            if (isValidEmail) {
                              UpdateEmail(Id);
                            } else {
                              Swal.fire({
                                title: "please enter your email address",
                                icon: "error",
                                confirmButtonText: "OK",
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* MODEL OF KYC  */}
            <Modal
              show={showKyc}
              onHide={handleCloseKyc}
              className=" kyc_popup"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <ul
                className="nav nav-tabs mb-2"
                id="myTab"
                role="tablist"
                style={{ justifyContent: "center" }}
              >
                {addCaseSetting.onlineKYC && (
                  <li className="nav-item mr-2" role="presentation">
                    <button
                      className="nav-link active tabs"
                      id="informative-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#informative"
                      type="button"
                      role="tab"
                      aria-controls="informative"
                      aria-selected="true"
                    >
                      Online KYC
                    </button>
                  </li>
                )}
                {addCaseSetting.offlineKYC && (
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link "
                      id="game-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#game"
                      type="button"
                      role="tab"
                      aria-controls="game"
                      aria-selected="true"
                    >
                      Offline KYC
                    </button>
                  </li>
                )}
              </ul>
              <div className="tab-content" id="myTabContent">
                {addCaseSetting.onlineKYC && (
                  <div
                    className="tab-pane fade show active"
                    id="informative"
                    role="tabpanel"
                    aria-labelledby="informative-tab"
                  >
                    <div className="input-group input-group-sm mb-2 ">
                      <label className="commaon_label">
                        Enter your Aadhar Number
                      </label>
                      <input
                        type="number"
                        className="commaon_input_box border border"
                        aria-describedby="basic-addon1"
                        value={AadharNum}
                        placeholder="Aadhar Number"
                        onChange={handleAdharChnage}
                      />
                    </div>
                    <div className="input-group input-group-sm mb-2 ">
                      <label className="commaon_label">Enter your Email</label>
                      <input
                        type="email"
                        className="commaon_input_box border border"
                        aria-describedby="basic-addon1"
                        value={Email}
                        placeholder="Enter Email"
                        onChange={handleEmailChange}
                      />
                      <h5 className="mt-2" style={{ color: "red" }}>
                        {msg}
                      </h5>
                      {isLoading ? (
                        <div
                          className="pl-2 text-center d-flex"
                          style={{
                            justifyContent: "center",
                            width: "100%",
                            marginTop: "10px",
                          }}
                        >
                          <img
                            src={findGif}
                            style={{
                              width: "50px",
                              height: "50px",
                              margin: "auto",
                            }}
                          />
                        </div>
                      ) : !userAdharData?.status === true ||
                        userAdharData.data?.status === "error" ? (
                        <div className="text-center">
                          <button
                            onClick={AdharNumber}
                            className="profile_wallet mt-2"
                          >
                            Send OTP
                          </button>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {userAdharData?.status === true &&
                    userAdharData?.data?.message === "OTP sent successfully" ? (
                      <div className="input-group input-group-sm mb-2">
                        <label className="commaon_label">Enter OTP</label>
                        <input
                          type="number"
                          className="commaon_input_box border"
                          aria-describedby="basic-addon1"
                          value={AadharOtp}
                          onChange={handleAdharOtpChnage}
                        />

                        {isLoading1 ? (
                          <div
                            className="pl-2 text-center d-flex"
                            style={{
                              justifyContent: "center",
                              width: "100%",
                              marginTop: "10px",
                            }}
                          >
                            <img
                              src={findGif}
                              style={{ width: "50px", height: "50px" }}
                              alt="Loading..."
                            />
                          </div>
                        ) : (
                          <div className="text-center">
                            <button
                              onClick={AdharOtp}
                              className={`profile_wallet mt-2 ${
                                isLoading1 ? "loading" : ""
                              }`}
                              disabled={isLoading1}
                            >
                              Submit OTP
                            </button>
                          </div>
                        )}
                      </div>
                    ) : (
                      " "
                    )}
                  </div>
                )}
                {addCaseSetting.offlineKYC && (
                  <div
                    className={`tab-pane fade ${!addCaseSetting.onlineKYC && addCaseSetting.offlineKYC ? "show active" : ""}`}
                    id="game"
                    role="tabpanel"
                    aria-labelledby="game-tab"
                  >
                    <div class="input-group input-group-sm mb-2">
                      <label className="commaon_label">Enter Name</label>
                      <input
                        type="text"
                        class="commaon_input_box border"
                        value={Names}
                        onChange={(e) => setNames(e.target.value)}
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div class="input-group input-group-sm mb-2">
                      <label className="commaon_label">
                        Enter Aadhar Number
                      </label>
                      <input
                        type="text"
                        class="commaon_input_box border"
                        value={AadharNum}
                        onChange={handleAdharChnage}
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div class="input-group input-group-sm mb-2">
                      <label className="commaon_label">Enter your Email</label>
                      <input
                        type="email"
                        class="commaon_input_box border"
                        value={Email}
                        onChange={handleEmailChange}
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div class="input-group input-group-sm mb-2">
                      <label className="commaon_label">Enter DOB</label>
                      <input
                        type="date"
                        class="commaon_input_box border"
                        value={DOB}
                        onChange={(e) => setDob(e.target.value)}
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                    <div class="input-group input-group-sm mb-2">
                      <label className="commaon_label">Front Image</label>
                      <input
                        class="commaon_input_box border"
                        id="frontPhoto"
                        name="frontPhoto"
                        type="file"
                        onChange={(e) => setFrontLoaded(e.target.files)}
                        accept="image/*"
                        required
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>

                    <div class="input-group input-group-sm mb-2">
                      <label className="commaon_label">Back Image</label>
                      <input
                        id="backPhoto"
                        name="backPhoto"
                        type="file"
                        accept="image/*"
                        onChange={(e) => setBackLoaded(e.target.files)}
                        class="commaon_input_box border"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        required
                      />
                    </div>
                    <div className="text-center">
                      <button
                        className="profile_wallet mt-2 mb-2"
                        onClick={handleSubmitdata}
                      >
                        submit
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseKyc}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </div>

          <div className="modern_action_container mb-4">
            <div className="action_grid">
              {/* WALLET TILE */}
              <Link to="/Addcase" className="action_tile wallet_tile">
                <div className="action_icon_wrapper">
                  <img
                    src={process.env.PUBLIC_URL + "/addcash.png"}
                    alt="Wallet"
                  />
                </div>
                <div className="action_text_content">
                  <h2 className="action_main_title">Wallet</h2>
                  <span className="action_sub_text">Manage Funds</span>
                </div>
                <div className="action_arrow_icon">
                  <i className="fa fa-chevron-right"></i>
                </div>
              </Link>

              {/* KYC TILE */}
              <div
                className={`action_tile kyc_tile ${profile?.verified === "verified" ? "verified_border" : ""}`}
              >
                <div className="action_icon_wrapper">
                  <img src="/images/kyc-icon-new.png" alt="KYC" />
                </div>

                <div className="action_text_content">
                  <h4 className="action_label">KYC STATUS</h4>

                  {profile && profile.verified === "verified" ? (
                    <div
                      className="status_message verified_text"
                      onClick={handleShowBottom}
                    >
                      Kyc Verified ✅
                    </div>
                  ) : profile && profile.verified === "pending" ? (
                    <div className="status_message pending_text">
                      In Process ⌚
                    </div>
                  ) : (
                    <div
                      className="status_message unverified_text"
                      onClick={Kyc}
                    >
                      {profile && profile.verified === "reject"
                        ? "KYC Rejected ❌"
                        : "Complete Verification"}
                    </div>
                  )}
                </div>

                <div className="action_arrow_icon">
                  <i className="fa fa-chevron-right"></i>
                </div>
              </div>
            </div>
          </div>

          {/* MODEL KYC USER DETAIL */}
          {/* <Modal
            show={showBottom}
            onHide={handleCloseBottom}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body className="transaction_details_modal_body">
              <div className="bank_detail">
                <div className="d_flex">
                  <h2>Name :</h2>
                  <h2>DILKHUSH MEENA</h2>
                </div>
                <div className="d_flex">
                  <h2>Adhar Number:</h2>
                  <h2>125263456845</h2>
                </div>
                <div className="d_flex">
                  <h2>Gender</h2>
                  <h2>MALE</h2>
                </div>
                <div className="d_flex">
                  <h2>DOB</h2>
                  <h2>04/08/1998</h2>
                </div>
                <div className="d_flex">
                  <h2>Email</h2>
                  <h2>dilkhush002@gmail.com</h2>
                </div>
              </div>
              <div className="Upi_Detail">
                <div className="d_flex">
                  <h2>Address:</h2>
                  <h2>Lalsot</h2>
                </div>
              </div>
            </Modal.Body>
          </Modal> */}

          {profile && !profile.referral && open == true && (
            <div className="modern_refer_container">
              <div className="refer_glass_card">
                <div className="refer_icon_area">
                  <img src="/images/referEarn.png" alt="Refer" />
                </div>

                <div className="refer_input_content">
                  <h2 className="modern_refer_title">Have a Referral Code?</h2>
                  <p className="refer_subtitle">
                    Enter it below to claim your bonus!
                  </p>

                  <div className="modern_input_wrapper">
                    <input
                      type="text"
                      className="modern_refer_input"
                      value={referral}
                      onChange={(e) => {
                        setCode(e.target.value);
                      }}
                      placeholder="Ex: REFER100"
                    />
                    <button
                      className="modern_apply_btn"
                      onClick={() => {
                        update_RefCode();
                      }}
                    >
                      <img
                        src="/images/select-blue-checkIcon.png"
                        alt="Apply"
                        className="apply_check_icon"
                      />
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="game_details_section mt-4">
            <div className="modern_section_header">
              <span className="header_line"></span>
              <h2 className="title text-uppercase">Game Details</h2>
              <span className="header_line"></span>
            </div>

            <div className="bento_stats_grid">
              {/* Coin Won - Large Box */}
              <div className="bento_card battle_played_card">
                <div className="bento_icon_circle bg_green_glow">
                  <img src="/global-cash-won-green-circular.png" alt="coin" />
                </div>
                <div className="bento_info">
                  <h3>Coin Won</h3>
                  <h4>₹{profile && profile.wonAmount}</h4>
                </div>
                <div className="card_bg_glow"></div>
              </div>

              {/* Battle Played - Small Box */}
              <div className="bento_card battle_played_card">
                <div className="bento_icon_circle bg_pink_glow">
                  <img
                    src="/images/battle.png"
                    alt="battle"
                    className="img-fluid"
                  />
                </div>
                <div className="bento_info">
                  <h3>Battles</h3>
                  <h4>{total && total}</h4>
                </div>
              </div>

              {/* Referral - Small Box */}
              <div className="bento_card referral_card">
                <div className="bento_icon_circle bg_blue_glow">
                  <img
                    src="/images/earning.png"
                    alt="earning"
                    className="img-fluid"
                  />
                </div>
                <div className="bento_info">
                  <h3>Referral</h3>
                  <h4>₹{profile && profile.referral_earning}</h4>
                </div>
              </div>
            </div>
          </div>

          <div className="modern_logout_wrapper mt-1 mb-3">
            <Link
              to="/login"
              className="premium_logout_btn"
              onClick={(e) => logout(e)}
            >
              <div className="logout_content">
                <div className="logout_icon_box">
                  <img
                    height="40px"
                    width="40px"
                    src="/images/icons/check-out.png"
                    alt=""
                  />
                </div>
                <span className="logout_text">Log Out of Account</span>
              </div>
              <div className="logout_arrow">
                <img
                  height="30px"
                  width="30px"
                  src="/images/icons/turn-off.png"
                  alt=""
                />
              </div>
            </Link>
          </div>
        </div>
      }

      <div className="rightContainer">
        <Rightcontainer />
      </div>
      {/* <ModalProfile style3={
                profileModalstyle
            } Enter={Enter}/> */}
      <div className={css.kyc_select} id="profileModal">
        <div className={css.overlay} />
        <div
          className={`${css.box}`}
          style={{
            bottom: "0px",
            position: "absolute",
          }}
        >
          <div className={css.bg_white}>
            <div className={`${css.header} ${css.cxy} ${css.flex_column}`}>
              <picture>
                <img
                  height="80px"
                  width="80px"
                  src="/images/avatars/Avatar2.png"
                  alt=""
                />
              </picture>
              <div className={`${css.header_text} mt-2`}>Choose Avatar</div>
            </div>
            <div className="mx-3 pb-3" style={{ paddingTop: "200px" }}>
              <div className="row justify-content-between col-10 mx-auto">
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar1.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar2.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar3.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar4.png"
                  alt=""
                />
              </div>
              <div className="row justify-content-between col-10 mx-auto mt-3">
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar5.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar6.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar7.png"
                  alt=""
                />
                <img
                  height="50px"
                  width="50px"
                  src="/images/avatars/Avatar8.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Profile1;
